import { IotaClient } from '@iota/iota-sdk/client';
import type { WalletAccount } from '@wallet-standard/core';
import BigNumber from 'bignumber.js';

import { prepareCoinsTransaction } from 'modules/api';
import { Env } from 'modules/common';

import { getConfig } from '../const/getConfig';

export async function createUnstakeTransaction(
  env: Env,
  walletAccount: WalletAccount,
  amount: BigNumber,
  client: IotaClient,
) {
  const config = getConfig(env);

  const { transaction, preparedCoins: unstakingCoins } =
    await prepareCoinsTransaction({
      walletAccount,
      client,
      amount,
      coinType: config.unstake.token,
    });

  transaction.moveCall({
    target: config.unstake.target,
    arguments: [
      transaction.object(config.stake.nativePoolId),
      transaction.object(config.stake.iotaSystemState),
      transaction.object(config.stake.certMetadata),
      unstakingCoins,
    ],
  });
  return { transaction };
}
